let elementUpdated = false;

export const setElementUpdated = (value: boolean) => {
  elementUpdated = value;
};

export const getElementUpdated = () => {
  return elementUpdated;
};
